import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { BouLinkExternal } from '@upright/ui/common/generic/content/texts/bou-link';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { KBLink, KBUrl } from '@upright/ui/common/upright/kb-urls';

export function MonetaryFigureNotes() {
  const context = useNetImpactLensContext();
  const selection = context?.state;
  const impact = selection?.impact;

  if (impact === ImpactCategoryId.GHG_EMISSIONS) {
    return (
      <>
        <p>Monetization approach based on ISO 14044:2006.</p>
        <p>Assumes social cost of carbon of 417€ per ton based on Ricke et al (2017).</p>
        <p>
          <KBLink target="_blank" href={KBUrl.MONETIZATION}>
            Read more
          </KBLink>
        </p>
      </>
    );
  } else if (impact === ImpactCategoryId.TAXES) {
    return (
      <div>
        <p>
          The dollar values <b>should not be expected to be equal to the company's own reporting</b> of their tax
          contribution, because:
        </p>
        <ul>
          <li>
            A significant part of tax revenue created by the company directly will be attributed to its suppliers,
            customers, and possibly other companies that enable its activities.
          </li>
          <li>Similarily, each company will be attributed tax impacts from their suppliers and customers.</li>
          <li>
            The tax categories Upright considers part of the company's tax contribution will likely differ from the
            definitions used by the company. Upright's definitions are largely based on the{' '}
            <BouLinkExternal
              href={'https://www.pwc.com/gx/en/services/tax/publications/total-tax-contribution-framework.html'}
            >
              Total Tax Contribution Framework
            </BouLinkExternal>{' '}
            that is being used by international organizations, such as the World Bank and Eurostat. Upright's main
            difference to the Total Tax Contribution Framework is that Upright does not consider social security
            payments, since they consist mainly of pension payments that do not end up financing common resources.
          </li>
        </ul>
        <p>
          <KBLink target="blank" href={KBUrl.ATTRIBUTION}>
            Read more on impact attribution
          </KBLink>
        </p>
      </div>
    );
  } else {
    return (
      <>
        <p>Monetization approach based on ISO 14044:2006.</p>
        <p>
          <KBLink target="blank" href={KBUrl.MONETIZATION}>
            Read more
          </KBLink>
        </p>
      </>
    );
  }
}
